import React, { ReactNode, useReducer, useRef } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import IconButton from 'components/Shared/Buttons/IconButton';
import PlusIcon from 'components/Shared/SearchFilter/PlusIcon';
import * as _ from 'lodash-es';
import {
  childrenContainerStyles,
  useAccordionStyles,
  useAccordionSummaryStyles,
  useAccordionDetailStyles,
} from './styles';

interface SearchFilterAccordionProps {
  title: string;
  children?: ReactNode;
  expanded?: boolean;
  onClick?: (isExpanding: boolean) => Promise<void>;
}

export default function FilterContainer({
  title,
  children,
  expanded: initialExpanded,
  onClick,
}: SearchFilterAccordionProps): JSX.Element {
  const [isExpanded, toggle] = useReducer((expanded) => !expanded, !!initialExpanded);
  const accordionClasses = useAccordionStyles();
  const accordionSummaryClasses = useAccordionSummaryStyles();
  const accordionDetailClasses = useAccordionDetailStyles();

  const ref = useRef<HTMLDivElement>(null);

  function onClickToggle(): void {
    onClick?.(!isExpanded);
    toggle();
  }

  const accordionSummaryId = `filter-container-summary-${_.camelCase(title)}`;
  const accordionDetailId = `filter-container-details-${_.camelCase(title)}`;

  return (
    <Accordion square expanded={isExpanded} classes={accordionClasses}>
      <AccordionSummary
        aria-controls={accordionDetailId}
        id={accordionSummaryId}
        classes={accordionSummaryClasses}
        onClick={onClickToggle}
        data-testid="accordion-toggle"
      >
        <div className="filter-title">{title}</div>
        <IconButton
          className="filter-container-icon-button"
          style={{
            margin: 0,
            padding: 0,
            textTransform: 'none',
            boxSizing: 'unset',
            backgroundColor: 'transparent',
            display: 'contents',
          }}
          aria-controls={accordionDetailId}
          aria-label="expand-toggle"
          aria-haspopup="true"
          aria-expanded={isExpanded ? 'true' : undefined}
        >
          <PlusIcon isRotated={isExpanded} />
        </IconButton>
      </AccordionSummary>
      <AccordionDetails classes={accordionDetailClasses}>
        <>
          <div className="children-container" ref={ref}>
            {children}
          </div>
          <style jsx>{childrenContainerStyles}</style>
        </>
      </AccordionDetails>
    </Accordion>
  );
}
